import React from 'react';

import { AddFriend } from '../components/control/AddFriend';
import { AddEventToCalendar } from '../components/control/AddEventToCalendar';
import { ClaimResult } from '../components/control/ClaimResult';
import { HeartThisPage } from '../components/control/HeartThisPage';
import { CommentOnThisPage } from '../components/control/CommentOnThisPage';
import { CheerResult } from '../components/control/CheerResult';
import {AddRaceModal} from '../components/modal/AddRaceModal';
import {Follow} from '../components/shared/Follow';
import {CommentResult} from '../components/control/CommentResult';
import {AddUnofficialResult} from '../components/control/AddUnofficialResult';
import {RemoveUnofficialResults} from '../components/control/RemoveUnofficialResults';

export const ControlFactory = {
  get: (modal, props) => {
    const key = modal.props.control;
    // noinspection JSUnusedGlobalSymbols
    // noinspection JSUnusedGlobalSymbols
    // noinspection JSUnusedGlobalSymbols
    // noinspection JSUnusedGlobalSymbols
    const controls = {
      heart: () => (<HeartThisPage modal={modal} {...props}/>),
      commentResult: () => (<CommentResult modal={modal} {...props}/>),
      addFriend: () => (<AddFriend modal={modal} {...props}/>),
      claimResult: () => (<ClaimResult modal={modal} {...modal.props} {...props}/>),
      comment: () => (<CommentOnThisPage modal={modal} {...props}/>),
      addEventToCalendar: () => (<AddEventToCalendar modal={modal} {...props}/>),
      cheerResult: () => (<CheerResult modal={modal} {...props}/>),
      addRace: () => <AddRaceModal modal={modal} {...modal.props} {...props}/>,
      follow: () => <Follow modal={modal} {...modal.props} {...props}/>,
      addUnofficialResult: () => (<AddUnofficialResult
        modal={modal}
        test="test" 
        {...modal.props} 
        {...props}/>
      ),
      removeResultsUnofficial: () => ( <RemoveUnofficialResults modal={modal} {...modal.props} {...props} />)
    };

    return controls[key] ? controls[key]() : null;
  }
};






/** WEBPACK FOOTER **
 ** ./utils/ControlFactory.js
 **/